module.exports = __webpack_public_path__ + "static/media/jp.cec721a8.webp";